import { MusicStyleInterface, MusicStyleStatusEnum } from '../../..';

export class MusicStylesDto implements MusicStyleInterface {
  id: string;
  musicStyleStatus: MusicStyleStatusEnum;
  translationKey: string;
}
